export default "__VITE_ASSET__Zn49My9c__"